import {
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  Select,
  MenuItem,
} from "@mui/material";
import { Textarea } from "@mui/joy";
import { useEffect, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteIcon from "@mui/icons-material/Delete";
import Account from "../../../utils/apiConfig";
import ApiServices from "../../../service/apiService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FormattedMessage, useIntl } from "react-intl";

import { Alert } from "@mikros/shared-ui";
import { useNavigate } from "react-router-dom";
import ErrorHandler from "../../../utils/errorConfig";
import { AuditQuestion, PerformanceAuditView } from "@mikros/library";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

interface AuditRow {
  id: number;
  Q: string;
  C: string;
}

export interface CreateAuditQuestionProps {
  auditDialogToggle?: Function;
  auditDialogValue?: boolean;
  auditType?: string;
}
export function CreateAuditQuestion(props: CreateAuditQuestionProps) {
  const intl = useIntl();
  const navigate = useNavigate();
  const errorInstance = ErrorHandler.getErrorInstance();
  const accountInstance = Account.getInstance();
  const [auditName, setAuditName] = useState<string>("");
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [rows, setRows] = useState<AuditRow[]>([{ id: 1, Q: "", C: "" }]);
  const [handleAuditQuestionSuccess, setHandleAuditQuestionSuccess] =
    useState(false);

  const [auditData, setAuditData] = useState<PerformanceAuditView>({
    auditName: "",
    auditId: "",
    auditQuestions: [],
    recType: "",
    updatedAt: "",
    entityId: "",
    createdAt: "",
    latestQuestions: "",
  });

  const [auditList, setAuditList] = useState<any>("");

  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  console.log("audit data print", auditData);

  console.log("props audit dialog toggle", props.auditDialogValue);
  console.log("props audit type", props.auditType);

  const handleChangeAuditName = (event: { target: { value: any } }) => {
    setAuditName(event.target.value);
  };
  const toggleAuditQuestionSuccessDialog = () => {
    setHandleAuditQuestionSuccess(!handleAuditQuestionSuccess);
  };
  const validateAuditName = (value: string) => {
    if (!value) {
      return "Audit name is required";
    }
    if (value.length > 50) {
      return "Audit name must be less than 50 characters";
    }
  };
  const handleAuditNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    if (value.length > 50) {
      return;
    }
    setAuditName(event.target.value);
    const error = validateAuditName(value);
    setErrors({ auditName: error || "" });
  };

  const handleQChange = (id: number, value: string) => {
    setRows(rows.map((row) => (row.id === id ? { ...row, Q: value } : row)));
  };

  const handleCChange = (id: number, value: string) => {
    setRows(rows.map((row) => (row.id === id ? { ...row, C: value } : row)));
  };

  const moveRowUp = (index: number) => {
    if (index > 0) {
      if (props.auditType === "NEW") {
        const newRows = [...rows];
        [newRows[index], newRows[index - 1]] = [
          newRows[index - 1],
          newRows[index],
        ];
        setRows(newRows);
      } else {
        const newQuestions = [...auditData.auditQuestions];
        [newQuestions[index], newQuestions[index - 1]] = [
          newQuestions[index - 1],
          newQuestions[index],
        ];
        setAuditData({
          ...auditData,
          auditQuestions: newQuestions,
        });
      }
    }
  };

  const moveRowDown = (index: number) => {
    if (
      index <
      (props.auditType === "NEW"
        ? rows.length - 1
        : auditData.auditQuestions.length - 1)
    ) {
      if (props.auditType === "NEW") {
        const newRows = [...rows];
        [newRows[index], newRows[index + 1]] = [
          newRows[index + 1],
          newRows[index],
        ];
        setRows(newRows);
      } else {
        const newQuestions = [...auditData.auditQuestions];
        [newQuestions[index], newQuestions[index + 1]] = [
          newQuestions[index + 1],
          newQuestions[index],
        ];
        setAuditData({
          ...auditData,
          auditQuestions: newQuestions,
        });
      }
    }
  };

  const handleAddRow = () => {
    console.log("inside handle add row check");
    if (props.auditType === "NEW") {
      const newId = Math.max(...rows.map((row) => row.id)) + 1;
      setRows([...rows, { id: newId, Q: "", C: "" }]);
    } else {
      const newId =
        Math.max(...auditData.auditQuestions.map((_, index) => index)) + 1;
      setAuditData({
        ...auditData,
        auditQuestions: [...auditData.auditQuestions, { Q: "", C: [] }],
      });
    }
  };

  const handleDeleteRow = (indexToDelete: number) => {
    console.log("inside handle delete row clicked");
    if (props.auditType === "NEW") {
      setRows((prevRows) =>
        prevRows.filter((_, index) => index !== indexToDelete)
      );
    } else {
      console.log("inside handle delete row click for edit");

      setAuditData((prevAuditData) => {
        if (!prevAuditData || !prevAuditData.auditQuestions) {
          console.error("auditData or auditQuestions is undefined");
          return prevAuditData;
        }

        return {
          ...prevAuditData,
          auditQuestions: prevAuditData.auditQuestions.filter(
            (_, index) => index !== indexToDelete
          ),
        };
      });
    }
  };

  const handleClear = (field: string) => {
    setAuditName("");
  };

  const handleSubmit = async () => {
    let validationErrors: Record<string, string> = {};
    let hasRowError = false; // Flag to check if any row has an error

    if (!auditName.trim()) {
      validationErrors.auditName = intl.formatMessage({
        id: "audit.createAuditQuestion.auditNameValidation",
      });
    }

    rows.forEach((row) => {
      if (!row.Q.trim() || !row.C.trim()) {
        hasRowError = true;
      }
    });

    if (hasRowError) {
      validationErrors.rows = intl.formatMessage({
        id: "audit.createAuditQuestion.allRowsChecklistValidation",
      });
    }
    console.log("validation error print", validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const auditQuestions = rows.map((row) => ({
      Q: row.Q,
      C: row.C.split(/\r?\n/)
        .map((criteria) => criteria.trim())
        .filter((criteria) => criteria !== ""),
      // .map((criteria) =>
      //   criteria.endsWith("?") ? criteria : `${criteria}?`
      // ),
    }));

    const payload = {
      accntId: accountInstance.accntId,
      auditName,
      auditQuestions,
    };

    try {
      const api = ApiServices.getInstance();
      await api
        .makeRequest(`${accountInstance.accntId}/audit`, "POST", payload)
        .then(async (payload) => {
          if (payload && payload.errorMessage) {
            console.log("I entered error code handling for post audit qn");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(payload.errorMessage);
            return;
          } else {
            console.log("Audit data successfully created");
            toggleAuditQuestionSuccessDialog();
          }
        });
    } catch (error) {
      console.error("Error creating audit:", error);
    }
  };

  const handleUpdate = async () => {
    let validationErrors: Record<string, string> = {};
    let hasRowError = false;

    // Validate audit questions
    if (props.auditType === "EDIT") {
      auditData?.auditQuestions?.forEach((question) => {
        if (
          !question.Q.trim() ||
          !Array.isArray(question.C) ||
          question.C.length === 0
        ) {
          hasRowError = true;
        }
      });
    } else {
      rows.forEach((row) => {
        if (!row.Q.trim() || !row.C.trim()) {
          hasRowError = true;
        }
      });
    }

    if (hasRowError) {
      validationErrors.rows = intl.formatMessage({
        id: "audit.createAuditQuestion.allRowsChecklistValidation",
      });
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Ensure auditId and auditName are valid before proceeding
    if (!auditData.auditId || !auditData.auditName) {
      console.error("Invalid auditId or auditName:", auditData);
      return;
    }

    // Construct auditQuestions in the required format
    const auditQuestions =
      props.auditType === "EDIT"
        ? auditData.auditQuestions.map((question) => ({
            Q: question.Q.trim(), // Ensure no extra spaces
            C: Array.isArray(question.C)
              ? question.C.map((criteria) => criteria.trim()) // Trim whitespace
              : [],
          }))
        : rows.map((row) => ({
            Q: row.Q.trim(),
            C: row.C.split(/\r?\n/)
              .map((criteria) => criteria.trim())
              .filter((criteria) => criteria !== ""),
            // .map((criteria) => (criteria.endsWith("?") ? criteria : `${criteria}?`)),
          }));

    // Construct recType in required format
    const recTypeforPayload = `${auditData.auditName}_${auditData.auditId}`;

    // Final payload
    const payload = {
      recType: recTypeforPayload,
      auditId: auditData.auditId,
      accntId: accountInstance.accntId,
      auditName: auditData.auditName, // Ensuring correct auditName is passed
      auditQuestions,
    };

    console.log("Final Payload for PUT:", JSON.stringify(payload, null, 2));

    try {
      const api = ApiServices.getInstance();
      await api
        .makeRequest(`${accountInstance.accntId}/audit`, "PUT", payload)
        .then(async (payload) => {
          if (payload && payload.errorMessage) {
            console.log("entered error code handling in create audit qn");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(payload.errorMessage);
            return;
          } else {
            console.log("Audit data successfully updated");
            toggleAuditQuestionSuccessDialog();
          }
        });
    } catch (error) {
      // console.error("Error updating audit:", error.response?.data || error.message);
    }
  };

  useEffect(() => {
    let api = ApiServices.getInstance();
    if (accountInstance.accntId && props.auditType === "EDIT") {
      api
        .makeRequest(`${accountInstance.accntId}/audit/auditnames`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
          } else {
            setAuditList(data);
          }
        });
    }
  }, []);

  useEffect(() => {
    let api = ApiServices.getInstance();
    if (accountInstance.accntId && props.auditType === "EDIT" && auditName) {
      api
        .makeRequest(
          `${accountInstance.accntId}/audit?auditName=${auditName}`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("entered error code handling in audit");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
          } else {
            setAuditData(data);
          }
        });
    }
  }, [auditName]);

  return (
    <div>
      {errorFlag && (
        <Dialog
          // className="errorDialogue"
          open={errorFlag}
          PaperProps={{
            style: {
              width: "50vw",
              maxWidth: "70vw",
              padding: "1rem",
            },
          }}
          sx={{
            borderRadius: "10px",
            border: "2px solid var(--color-mk-red)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            "& .MuiPaper-root": {
              borderRadius: "10px", // Ensures the inner paper component has rounded corners
              border: "2px solid var(--color-mk-red)", // Ensures the border is applied
            },
          }}
        >
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                // navigate("/home");
                navigate("/home");
              } else {
                navigate("/audit");
              }
            }}
          />
        </Dialog>
      )}

      {handleAuditQuestionSuccess && (
        <Dialog
          PaperProps={{
            style: {
              width: "50vw",
              maxWidth: "70vw",
              padding: "1rem",
            },
          }}
          open={handleAuditQuestionSuccess}
          sx={{
            borderRadius: "10px",
            border: "2px solid var(--color-mk-bright-green)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            "& .MuiPaper-root": {
              borderRadius: "10px", // Ensures the inner paper component has rounded corners
              border: "2px solid var(--color-mk-bright-green)", // Ensures the border is applied
            },
          }}
        >
          <Alert
            description={
              props.auditType === "NEW"
                ? intl.formatMessage({
                    id: "audit.createAuditQuestion.auditCreatedSuccessfully",
                  })
                : intl.formatMessage({
                    id: "audit.createAuditQuestion.auditUpdatedSuccessfully",
                  })
            }
            buttonText={`${intl.formatMessage({ id: "users.buttonText.Ok" })}`}
            icon={"successShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgSuccess",
            })}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              toggleAuditQuestionSuccessDialog();
              if (props.auditDialogToggle) {
                props.auditDialogToggle(!props.auditDialogValue);
              }
            }}
          />
        </Dialog>
      )}
      <div className="flex justify-between items-center mt-2">
        <div className="text-mk-primary-bright text-2xl font-semibold ml-4">
          {props.auditType === "NEW"
            ? intl.formatMessage({
                id: "audit.createAuditQuestions.createNewAudit",
              })
            : intl.formatMessage({
                id: "audit.createAuditQuestions.updateAudit",
              })}
        </div>
        <div
          onClick={() => {
            console.log("enterd on click for audit dialog");
            console.log("props audit dialog toggle", props.auditDialogToggle);
            if (props.auditDialogToggle) {
              props.auditDialogToggle(!props.auditDialogValue);
            }
          }}
          className="pt-1 pb-1 pl-2 pr-2 rounded-full hover:cursor-pointer bg-mk-primary-50 mr-4"
        >
          <FontAwesomeIcon
            icon={["far", "fa-xmark" as IconName]}
            className="w-3 h-3"
          />
        </div>
      </div>
      <div className="pb-[1%]"></div>
      <FormControl margin="dense" sx={{ width: "16rem", ml: 2 }}>
        <Typography variant="subtitle1">Audit Name</Typography>

        {props.auditType === "NEW" ? (
          <TextField
            error={!!errors.auditName}
            helperText={errors.auditName}
            name="auditName"
            value={auditName}
            onChange={handleAuditNameChange}
            InputProps={{
              endAdornment: auditName && (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => handleClear("auditName")}
                    disableRipple
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        ) : (
          <FormControl margin="dense" sx={{ width: "16rem" }}>
            <Select
              value={auditName}
              onChange={handleChangeAuditName}
              displayEmpty
              renderValue={(selected) =>
                selected
                  ? selected
                  : intl.formatMessage({
                      id: "audit.createAuditQuestion.selectauditName",
                    })
              }
            >
              {Array.isArray(auditList?.result) &&
                auditList?.result?.map((audit: any) => (
                  <MenuItem key={audit?.auditName} value={audit?.auditName}>
                    {audit?.auditName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        )}
      </FormControl>
      <div className="pb-[1%]"></div>
      {errors.rows && (
        <Typography variant="subtitle1" color="error">
          {errors.rows}
        </Typography>
      )}

      <div style={{ marginRight: "1rem", marginLeft: "1rem" }}>
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "transparent !important",
                  "&:hover": { backgroundColor: "transparent !important" },
                }}
              >
                <TableCell sx={{ width: "5%", padding: "4px 8px !important" }}>
                  <FormattedMessage id="slNo" />
                </TableCell>
                <TableCell sx={{ width: "45%", padding: "4px 8px !important" }}>
                  <FormattedMessage id="users.auditView.checklist" />
                </TableCell>
                <TableCell sx={{ width: "45%", padding: "4px 8px !important" }}>
                  <FormattedMessage id="users.auditView.assessmentCriteria" />
                </TableCell>
                <TableCell
                  sx={{ width: "2.5%", padding: "0 !important" }}
                ></TableCell>
                <TableCell
                  sx={{ width: "2.5%", padding: "0 !important" }}
                ></TableCell>
              </TableRow>
            </TableHead>

            {props.auditType === "NEW" ? (
              <TableBody
                sx={{
                  "&:hover": { backgroundColor: "transparent !important" },
                }}
              >
                {rows.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      "&:hover": { backgroundColor: "transparent !important" },
                      height: "80px",
                    }}
                  >
                    <TableCell sx={{ padding: "4px 8px !important" }}>
                      {index + 1}
                    </TableCell>
                    <TableCell sx={{ padding: "4px 8px !important" }}>
                      <Textarea
                        minRows={2}
                        maxRows={4}
                        value={row.Q}
                        onChange={(e) => handleQChange(row.id, e.target.value)}
                        size="sm"
                        sx={{
                          backgroundColor: "var(--color-mk-white)",
                          border: "1px solid #E1E2E9",
                          "&::before, &::after": {
                            display: "none !important",
                          },
                          "&:focus-within": {
                            border: "2px solid var(--color-mk-primary)",
                          },
                          margin: "2px 0",
                        }}
                      />
                    </TableCell>
                    <TableCell sx={{ padding: "4px 8px !important" }}>
                      <Textarea
                        minRows={2}
                        maxRows={4}
                        value={row.C}
                        onChange={(e) => handleCChange(row.id, e.target.value)}
                        size="sm"
                        sx={{
                          backgroundColor: "var(--color-mk-white)",
                          border: "1px solid #E1E2E9",
                          "&::before, &::after": {
                            display: "none !important",
                          },
                          "&:focus-within": {
                            border: "2px solid var(--color-mk-primary)",
                          },
                          margin: "2px 0",
                        }}
                      />
                    </TableCell>
                    <TableCell
                      sx={{ padding: "0 !important", textAlign: "center" }}
                    >
                      <div style={{ display: "flex", gap: "4px" }}>
                        <IconButton
                          onClick={() => moveRowUp(index)}
                          disabled={index === 0}
                          size="small"
                        >
                          <ArrowUpwardIcon
                            sx={{
                              height: "20px",
                              width: "20px",
                              color: "var(--color-mk-primary)",
                            }}
                          />
                        </IconButton>
                        <IconButton
                          onClick={() => moveRowDown(index)}
                          disabled={index === rows.length - 1}
                          size="small"
                        >
                          <ArrowDownwardIcon
                            sx={{
                              height: "20px",
                              width: "20px",
                              color: "var(--color-mk-primary)",
                            }}
                          />
                        </IconButton>
                      </div>
                    </TableCell>
                    <TableCell
                      sx={{ padding: "0 !important", textAlign: "center" }}
                    >
                      <IconButton
                        // onClick={() => handleDeleteRow(row.id)}
                        onClick={() => handleDeleteRow(index)}
                        disabled={rows.length === 1}
                        sx={{ width: 30, height: 30 }}
                        disableFocusRipple
                        disableRipple
                      >
                        <DeleteIcon
                          sx={{
                            height: "20px",
                            width: "20px",
                            color: "var(--color-mk-primary)",
                          }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody
                sx={{
                  "&:hover": { backgroundColor: "transparent !important" },
                }}
              >
                {auditName ? (
                  auditData?.auditQuestions?.map(
                    (detail: AuditQuestion, index: number) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:hover": {
                            backgroundColor: "transparent !important",
                          },
                          height: "80px",
                        }}
                      >
                        <TableCell sx={{ padding: "4px 8px !important" }}>
                          {index + 1}
                        </TableCell>
                        <TableCell sx={{ padding: "4px 8px !important" }}>
                          <Textarea
                            minRows={2}
                            maxRows={4}
                            value={detail.Q}
                            onChange={(e) => {
                              const updatedQuestions = [
                                ...auditData.auditQuestions,
                              ];
                              updatedQuestions[index] = {
                                ...updatedQuestions[index],
                                Q: e.target.value,
                              };
                              setAuditData({
                                ...auditData,
                                auditQuestions: updatedQuestions,
                              });
                            }}
                            size="sm"
                            sx={{
                              backgroundColor: "var(--color-mk-white)",
                              border: "1px solid #E1E2E9",
                              "&::before, &::after": {
                                display: "none !important",
                              },
                              "&:focus-within": {
                                border: "2px solid var(--color-mk-primary)",
                              },
                              margin: "2px 0",
                            }}
                          />
                        </TableCell>
                        <TableCell sx={{ padding: "4px 8px !important" }}>
                          <Textarea
                            minRows={2}
                            maxRows={4}
                            value={
                              Array.isArray(detail.C)
                                ? detail.C.join("\n")
                                : detail.C
                            }
                            onChange={(e) => {
                              const updatedQuestions = [
                                ...auditData.auditQuestions,
                              ];
                              updatedQuestions[index] = {
                                ...updatedQuestions[index],
                                C: e.target.value.split(/\r?\n/),
                              };
                              setAuditData({
                                ...auditData,
                                auditQuestions: updatedQuestions,
                              });
                            }}
                            size="sm"
                            sx={{
                              backgroundColor: "var(--color-mk-white)",
                              border: "1px solid #E1E2E9",
                              "&::before, &::after": {
                                display: "none !important",
                              },
                              "&:focus-within": {
                                border: "2px solid var(--color-mk-primary)",
                              },
                              margin: "2px 0",
                            }}
                          />
                        </TableCell>
                        <TableCell
                          sx={{ padding: "0 !important", textAlign: "center" }}
                        >
                          <div style={{ display: "flex", gap: "4px" }}>
                            <IconButton
                              onClick={() => moveRowUp(index)}
                              disabled={index === 0}
                              size="small"
                            >
                              <ArrowUpwardIcon
                                sx={{
                                  height: "20px",
                                  width: "20px",
                                  color: "var(--color-mk-primary)",
                                }}
                              />
                            </IconButton>
                            <IconButton
                              onClick={() => moveRowDown(index)}
                              // disabled={index === auditQu - 1}
                              disabled={
                                index === auditData.auditQuestions.length - 1
                              }
                              size="small"
                            >
                              <ArrowDownwardIcon
                                sx={{
                                  height: "20px",
                                  width: "20px",
                                  color: "var(--color-mk-primary)",
                                }}
                              />
                            </IconButton>
                          </div>
                        </TableCell>
                        <TableCell
                          sx={{ padding: "0 !important", textAlign: "center" }}
                        >
                          <IconButton
                            onClick={() => handleDeleteRow(index)}
                            disabled={
                              props.auditType === "EDIT"
                                ? auditData.auditQuestions.length === 1
                                : rows.length === 1
                            }
                            sx={{ width: 30, height: 30 }}
                            disableFocusRipple
                            disableRipple
                          >
                            <DeleteIcon
                              sx={{
                                height: "20px",
                                width: "20px",
                                color: "var(--color-mk-primary)",
                              }}
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    )
                  ) || (
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        className="text-center"
                      ></TableCell>
                    </TableRow>
                  )
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={5}
                      className="text-center text-mk-primary"
                    >
                      <div className="w-full h-full flex items-center justify-center text-center text-lg text-mk-primary-bright font-semibold mt-4">
                        <FormattedMessage id="audit.createAuditQuestion.enableCheclistValidation" />
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </div>

      <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
        <Button
          type="submit"
          variant="contained"
          disableRipple
          sx={{
            mt: 2,
            marginLeft: "1rem",
            borderRadius: "8px",
            textTransform: "capitalize",
            color: "white",
            backgroundColor: "#6464E5",
            "&:hover": {
              backgroundColor: "#E1E2E9",
              color: "black",
            },
            display: "inline-block",
          }}
          disabled={props.auditType === "EDIT" && !auditName}
          onClick={handleAddRow}
        >
          <FormattedMessage id="audit.createAuditQuestion.addRow" />
        </Button>
      </div>
      <div className="flex justify-end items-end gap-4 mr-4">
        <Button
          type="button" // Use 'button' type to prevent form submission
          variant="contained"
          disableRipple // Disable ripple effect
          sx={{
            mt: 2,
            borderRadius: "8px",
            textTransform: "capitalize",
            color: "black",

            backgroundColor: "#E1E2E9",
            "&:hover": {
              backgroundColor: "#E1E2E9",
            },

            display: "inline-block",
          }}
          onClick={() => {
            // handleClearAll();
            if (props.auditDialogToggle) {
              props.auditDialogToggle(!props.auditDialogValue);
            }
          }}
        >
          <FormattedMessage id="audit.createAuditQuestion.cancel" />
        </Button>
        <Button
          type="submit"
          variant="contained"
          disableRipple
          sx={{
            mt: 2,
            borderRadius: "8px",
            textTransform: "capitalize",
            color: "white",

            backgroundColor: "#6464E5",
            "&:hover": {
              backgroundColor: "#E1E2E9",
              color: "black",
            },
            display: "inline-block",
          }}
          disabled={props.auditType !== "NEW" && !auditName}
          onClick={props.auditType === "NEW" ? handleSubmit : handleUpdate}
        >
          {props.auditType === "NEW" ? "Save" : "Update"}
        </Button>
      </div>
    </div>
  );
}
